import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { TenantComponentsEntity } from '../../domain/entities/tenant-components.entity';

@Injectable({ providedIn: 'root' })
export class MyTenantComponentsRestApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);

  public getMyComponents(): Observable<TenantComponentsEntity> {
    return this._http.get<TenantComponentsEntity>(`${this._config.versionedApiUrl}/tenant-components`);
  }
}
